import React from 'react';
import PropTypes from 'prop-types';
import ReactLazyLoad from 'react-lazyload';
import { connect } from 'react-redux';

import Placeholder from 'components/Picture/Placeholder';

const LazyLoad = ({
  // Props
  children,
  placeholder,
  placeholderColor,
  offset,
  overflow,
  disableLazyLoad,
}, {
  // Context
  amp,
}) => {
  // Do not lazyload if disabled via query param or is AMP context
  if (disableLazyLoad || amp) {
    return children;
  }

  const config = {
    offset,
    overflow,
    once: true,
    height: 50,
  };

  const { props: childProps = {} } = children;

  // Extract className from child element to add to lazyload wrapper
  let className = '';
  const component = (
    React.Children.map(children, (child) => {
      const additionalChildProps = {};
      // Add lazyloaded attribute
      if (child.props && typeof child.props.lazyloaded === 'boolean') {
        additionalChildProps.lazyloaded = true;
      }
      // Placeholder requested
      if (placeholder) {
        // Copy className to wrapper element
        ({ className } = child.props);
        additionalChildProps.className = null;
      }
      return React.cloneElement(child, additionalChildProps);
    })
  );

  if (placeholder && childProps.responsiveFlavors) {
    return (
      <div className={`relative ${className}`}>
        <div className="absolute absolute-fill z-2 overflow-hidden">
          <ReactLazyLoad {...config}>
            {component}
          </ReactLazyLoad>
        </div>
        <div className="relative z-1">
          <Placeholder
            color={placeholderColor}
            responsiveFlavors={children.props.responsiveFlavors}
          />
        </div>
      </div>
    );
  }

  return (
    <ReactLazyLoad {...config}>
      {component}
    </ReactLazyLoad>
  );
};

LazyLoad.propTypes = {
  children: PropTypes.node.isRequired,
  placeholder: PropTypes.bool,
  placeholderColor: PropTypes.string,
  offset: PropTypes.number,
  overflow: PropTypes.bool,
  disableLazyLoad: PropTypes.bool,
};

LazyLoad.defaultProps = {
  placeholder: true,
  placeholderColor: 'knockout-secondary',
  offset: 200,
  overflow: false,
  disableLazyLoad: false,
};

LazyLoad.contextTypes = {
  amp: PropTypes.bool,
};

const mapStateToProps = ({
  shared: { disableLazyLoad },
}) => ({
  disableLazyLoad,
});

export default connect(mapStateToProps)(LazyLoad);
